(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneController', CommissioneController);

    CommissioneController.$inject = ['Commissione', 'Atto', '$stateParams', '$state'];

    function CommissioneController(Commissione, Atto, $stateParams, $state) {

        var vm = this;
        vm.basicSearchLegislatura = $stateParams.legislatura;

        vm.commissiones = [];
        vm.transition = transition;

        vm.legislature = [];
        Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);

        function onSuccessLeg(data){
            vm.legislature=data;
            if(vm.legislature && vm.legislature.indexOf(11) === -1) {
                vm.legislature.push(11);
            }
        }
        function onErrorLeg(error){
            console.log("Failure!", error);
            toastr.error(error.data.message);
        }

        loadAll();

        function loadAll() {
            Commissione.query({legislature: vm.basicSearchLegislatura, includeHidden: true}, function(result) {
                vm.commissiones = result;
                vm.searchQuery = null;
            });
        }


        function transition() {

            if(vm.basicSearchLegislatura && vm.basicSearchLegislatura !== 'ALL') {
                $state.transitionTo($state.$current, {
                    legislatura: vm.basicSearchLegislatura
                });
            }else {
                $state.transitionTo($state.$current, {
                    legislatura: null
                });
            }
        }
    }
})();
